import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailed } from './components/WhyItFailed';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { BonusSection } from './components/BonusSection';
import { PriceBlock } from './components/PriceBlock';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
import { trackAddToCart } from './utils/metaPixel';
import { DownloadIcon, CreditCardIcon } from 'lucide-react';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#FAFAF7]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItFailed data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsItFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <PriceBlock data-id="element-11" />
      <FaqSection data-id="element-12" />
      <Footer data-id="element-13" />
      <RecentPurchaseToast data-id="element-14" />
    </div>;
}